import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import decode from 'jwt-decode';
import { PermissionToolkitService, StorageService } from 'front-common-toolkits';
import { environment, httpBaseParam } from "../../../environments/environment";
import { TenantService } from "../../pages/tenant/services/tenant.service";
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import * as UserActions from "src/app/services/state/actions/user.action";
@Injectable()
export class AuthenticationService {
  currentUser: any;
  httpBase: string = httpBaseParam.httpBase;
  public token: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    private tenantService: TenantService,
    private cookieService: CookieService,
    private permissionToolkitService: PermissionToolkitService,
    private storageService: StorageService,
    private notification: NzNotificationService,
    private store: Store<AppState>,

  ) {
    // set token if saved in local storage
    const userStr = this.cookieService.get('currentUser');
    if (userStr) {
      this.currentUser = JSON.parse(userStr);
    }
  }

  getToken() {
    return this.currentUser ? this.currentUser.token : undefined;
  }

  async refreshToken(forceRefresh?) {
    const nextRefreshTimeStamp = this.storageService.getLocalItem('nextRefreshTime');
    if ((nextRefreshTimeStamp && new Date().getTime() > nextRefreshTimeStamp) || forceRefresh) {  // 
      console.log('check refresh time', nextRefreshTimeStamp);
      console.log('next Refresh Time' + moment(nextRefreshTimeStamp).format());
      let loginType = environment.isAdmin ? 'admin' : 'tenant';
      const httpBase = environment.isAdmin ? environment.httpBase : environment.tenantHttpBase;
      let refreshUrl = '/ten/auth/user/refresh_token';
      if (loginType !== 'tenant') {
        refreshUrl = '/adm/auth/refresh_token';
      }
      const refreshToken = this.storageService.getLocalItem('refreshToken');
      if (refreshToken) {
        try {
          const response = await this.http.post(httpBase + refreshUrl, '"' + refreshToken + '"',
            { headers: { "Content-Type": 'application/json' } }).toPromise();

            console.log('这是每次请求refreshToken返回的数据',response)
          if (response['code'] === 0) {

            const token = response['data']['accessToken'];
            const refreshToken = response['data']['refreshToken'];
            const accessTokenExpireMinutes = response['data']['accessTokenExpireMinutes'];
            this.storageService.setLocalItem('refreshToken', refreshToken);
            this.storageService.setLocalItem('accessTokenExpireMinutes', accessTokenExpireMinutes);
            this.cookieService.set('authTime', moment().format());
            this.storageService.setLocalItem('nextRefreshTime', moment().add(accessTokenExpireMinutes - 10, 'm').valueOf());
            // this.storageService.setLocalItem('nextRefreshTime', moment().add(2, 'm').valueOf());

            if (token) {
              this.token = token;
              //this.cookieService.set('tokenCheck', '1', moment().add(accessTokenExpireMinutes, 'm').toDate());
              this.cookieService.set('tokenCheck', '1', moment().add(30, 'd').toDate());
              this.cookieService.set('token', token);
            }
            return true;
          } else {
            console.log('请求的refreshToken',refreshToken)
            console.log('这是response[code] === 0的数据',response)
            return false;
          }
        } catch (e) {
          console.log('请求的refreshToken',refreshToken)
          console.log('请求的refreshToken报错内容', e);
          // console.error(e);
          return false
        }
      }else{
        console.log('refreshToken 本地没获取到',refreshToken)
      }
    }
    return true;
  }

  //自动刷新token  20220412
  // async autoRefreshToken() {
  //   const refreshToken = this.storageService.getLocalItem('refreshToken');
  //   // 计算时间间隔
  //   const nextRefreshTimeStamp = this.storageService.getLocalItem('nextRefreshTime');
  //   if ((nextRefreshTimeStamp)&& new Date().getTime() > nextRefreshTimeStamp ) {
  //     if (refreshToken) {
  //        (await this.newrefreshToken(refreshToken)).subscribe(
  //         res => {
  //           if (res['code'] === 0) {
  //             const tokenInfo = res['data'];
  //             const token = tokenInfo['accessToken'];
  //             const refreshToken = tokenInfo['refreshToken'];
  //             const accessTokenExpireMinutes = tokenInfo['accessTokenExpireMinutes'];

  //             this.storageService.setLocalItem('refreshToken', refreshToken);
  //             this.storageService.setLocalItem('accessTokenExpireMinutes', accessTokenExpireMinutes);
  //             this.cookieService.set('authTime', moment().format());
  //             this.storageService.setLocalItem('nextRefreshTime', moment().add(accessTokenExpireMinutes - 10, 'm').valueOf());

  //               if (token) {
  //                 // set token property
  //                 this.token = token;
  //                 const tokenPayload = decode(token);
  //                 //this.cookieService.set('tokenCheck', '1', moment().add(accessTokenExpireMinutes, 'm').toDate());
  //                 this.cookieService.set('tokenCheck', '1', moment().add(30, 'd').toDate());
  //                 this.cookieService.set('token', token);
  //                 return tokenPayload;
  //               } else {
  //                 // return false to indicate failed login
  //                 return null;
  //               }
  //             } else {
  //               // return false to indicate failed login
  //               return null;
  //             }
  //         },
  //         error => {  // 刷新token失败    删除token   删除refreshToken
  //           this.notification.create('error', 'RefreshToken过期', '请重新登录!');
  //           this.cookieService.delete('tenantLoginResult');
  //           this.store.dispatch(new UserActions.RemoveUser())
  //           this.router.navigate(['/login']);
  //         }
  //       )
  //     }else{
  //       this.notification.create('error', 'RefreshToken过期', '请重新登录!');
  //       this.cookieService.delete('tenantLoginResult');
  //       this.store.dispatch(new UserActions.RemoveUser())
  //       this.router.navigate(['/login']);
  //     }
  //   }
  // }
  // async newrefreshToken(token) {
  //   let loginType = environment.isAdmin ? 'admin' : 'tenant';
  //   let refreshUrl = '/ten/auth/user/refresh_token';
  //   if (loginType !== 'tenant') {
  //     refreshUrl = '/adm/auth/refresh_token';
  //   }
  //   let httpBase: string = environment.isAdmin ? environment.httpBase : environment.tenantHttpBase;
  //   return  this.http.post(httpBase + refreshUrl, '"' + token + '"',
  //   { headers: { "Content-Type": 'application/json' } });
  // }

  analyzeToken(token) {
    const headers = new HttpHeaders();
    headers['x-access-token'] = token;
    return this.http.get(environment.httpBase + '/fixedToken/auth', { headers: headers }).pipe(map(res => res['data'] || null));
  }

  login(username: string, password: string) {
    // return this.http.post(this.HOST_OLD + '/api/member/login', { userName: username, pwd: password })
    return this.http.post(environment.httpBase + '/adm/auth/login', { accountCode: username, pwd: password }).pipe(
      map(response => {
        // login successful if there's a jwt token in the response
        if (response['code'] === 0) {
          const account = response['data']['account'];
          const tokenInfo = response['data']['tokenInfo'];
          const token = tokenInfo['accessToken'];
          const refreshToken = tokenInfo['refreshToken'];
          const accessTokenExpireMinutes = tokenInfo['accessTokenExpireMinutes'];

          this.storageService.setLocalItem('accountId', account.accountId);
          this.storageService.setLocalItem('account', account);
          this.storageService.setLocalItem('refreshToken', refreshToken);
          this.storageService.setLocalItem('accessTokenExpireMinutes', accessTokenExpireMinutes);
          this.cookieService.set('authTime', moment().format());
          this.storageService.setLocalItem('nextRefreshTime', moment().add(accessTokenExpireMinutes - 5, 'm').valueOf());

          if (token) {
            // set token property
            this.token = token;
            const tokenPayload = decode(token);
            //this.cookieService.set('tokenCheck', '1', moment().add(accessTokenExpireMinutes, 'm').toDate());
            this.cookieService.set('tokenCheck', '1', moment().add(30, 'd').toDate());
            this.cookieService.set('token', token);
            return tokenPayload;
          } else {
            // return false to indicate failed login
            return null;
          }
        } else {
          // return false to indicate failed login
          return null;
        }
      }
      ));
  }

  getSmsCode(mobile) {
    return this.http.post(environment.tenantHttpBase + '/ten/auth/sms_code', mobile, { headers: { "Content-Type": 'application/json' } })
  }
  //修改密码
  pwd(data) {
    const httpBase = environment.isAdmin ? environment.httpBase+'/adm/auth/pwd' : environment.tenantHttpBase+ '/ten/auth/account/pwd';
    return this.http.post(httpBase , data, { headers: { "Content-Type": 'application/json' } })
  }
  //首次修改密码
  firstPwd(data){
    return this.http.post(environment.tenantHttpBase + '/ten/auth/account/first/pwd', data, { headers: { "Content-Type": 'application/json' } })
  }
  //获取当前用户信息
  getUserInfo(){
    return this.http.get(environment.tenantHttpBase + '/ten/auth/account',{ headers: { "Content-Type": 'application/json' } })
  }
  tenantLogin(param: any) {
    return this.http.post(environment.tenantHttpBase + '/ten/auth/account/login',
      param).pipe(
        map(response => {
          // login successful if there's a jwt token in the response
          if (response['code'] === 0) {
            this.storageService.setItem('tenantLoginResult', response['data'], moment().add(7, 'd').toDate());
            // this.storageService.setItem('tenantLoginResult', response['data'], moment().add(1, 'h').toDate());
            return response['data']
          } else {
            throw { message: '登录失败' };
          }
        }
        ));
  }

  loginCompany(accountLoginToken, tenantId) {
    return this.http.post(environment.tenantHttpBase + '/ten/auth/user/tenant/login',
      { accountLoginToken: accountLoginToken, tenantId: tenantId }).pipe(
        map(response => {
          return this.processCompanyLogin(response);
        }
        ));
  }

  switchCompany(tenantId) {
    return this.http.post(environment.tenantHttpBase + '/ten/auth/user/tenant/switch', tenantId,
      { headers: { "Content-Type": 'application/json' } }).pipe(
        map(response => {
          return this.processCompanyLogin(response);
        }
        ));
  }

  processCompanyLogin(response) {
    // login successful if there's a jwt token in the response
    if (response['code'] === 0) {
      const account = response['data']['user'];
      const tokenInfo = response['data']['tokenInfo'];
      const token = tokenInfo['accessToken'];
      const refreshToken = tokenInfo['refreshToken'];
      const accessTokenExpireMinutes = tokenInfo['accessTokenExpireMinutes'];


      this.storageService.setLocalItem('userId', account.userId);
      this.storageService.setLocalItem('refreshToken', refreshToken);
      this.storageService.setLocalItem('accessTokenExpireMinutes', accessTokenExpireMinutes);
      this.cookieService.set('authTime', moment().format());
      this.storageService.setLocalItem('nextRefreshTime', moment().add(accessTokenExpireMinutes - 5, 'm').valueOf());
      // this.storageService.setLocalItem('nextRefreshTime', moment().add(2, 'm').valueOf());

      if (token) {
        // set token property
        this.token = token;
        const tokenPayload = decode(token);
        //this.cookieService.set('tokenCheck', '1', moment().add(accessTokenExpireMinutes, 'm').toDate());
        this.cookieService.set('tokenCheck', '1', moment().add(30, 'd').toDate());
        this.cookieService.set('token', token);
        return tokenPayload;
      } else {
        // return false to indicate failed login
        return null;
      }
    } else {
      // return false to indicate failed login
      return null;
    }
  }

  logOut() {
    return this.http.delete(environment.httpBase + '/base/auth');
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    this.token = undefined;
    this.currentUser = undefined;
    this.storageService.clearUserInfo();
  }
}
